import { render, staticRenderFns } from "./RubricIcon.vue?vue&type=template&id=30fad662"
import script from "./RubricIcon.vue?vue&type=script&lang=js"
export * from "./RubricIcon.vue?vue&type=script&lang=js"
import style0 from "./RubricIcon.vue?vue&type=style&index=0&id=30fad662&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports